module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=IM - Isle of Man.a3df8770.svg";